export const configTemplate = {
  options: {
    defaultThresholds: {
      warning: 10,
      critical: 20,
      levels: ["OK", "WARNING", "ERROR"]
    },
    metrics: {
      lcom: {
        enabled: true,
        warning: 5,
        critical: 10
      },
      wmc: {
        enabled: true,
        warning: 10,
        critical: 25
      },
      rfc: {
        enabled: true,
        warning: 15,
        critical: 30
      },
      cbo: {
        enabled: true
      }
    }
  },
  includes: ['**/*.ts', '!**/*.d.ts'],
  excludes: [
    "**/*.test.ts",
    "node_modules",
    "dist",
    "scripts/**"
  ]
}
